import { useEffect, useRef } from "react";
import { fileUrl, fmtTime } from "@/lib/api";

export const Attachment = ({ a }) =>
  a.kind === "image" ? (
    <a href={fileUrl(a.file_id)} target="_blank" rel="noreferrer">
      <img src={fileUrl(a.file_id)} alt={a.name} className="mt-1 max-h-64 rounded-xl object-cover" data-testid="message-image" />
    </a>
  ) : (
    <video src={fileUrl(a.file_id)} controls className="mt-1 max-h-64 rounded-xl" data-testid="message-video" />
  );

export const MessageBubble = ({ m, mine, name }) => (
  <div className={`flex flex-col ${mine ? "items-end" : "items-start"} rise`} style={{ animationDuration: ".3s" }} data-testid="chat-message">
    <span className="mb-1 px-1 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
      {name} · {fmtTime(m.created_at)}
    </span>
    <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed break-words ${mine ? "rounded-br-md bg-[#FF3B6C] text-white" : "rounded-bl-md bg-[#241E3D]"}`}>
      {m.text && <p className="whitespace-pre-wrap">{m.text}</p>}
      {m.attachment && <Attachment a={m.attachment} />}
    </div>
  </div>
);

export const MessageList = ({ messages, partnerNick, typing, children }) => {
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, typing]);
  return (
    <div className="scroll-thin flex-1 space-y-4 overflow-y-auto p-4" data-testid="chat-messages-list">
      {children}
      {messages.map((m) => <MessageBubble key={m.id} m={m} mine={m.mine} name={m.mine ? "Te" : partnerNick || "Ismeretlen"} />)}
      {typing && <div className="dot-bounce pl-2" data-testid="partner-typing"><span className="bg-[#00F0FF]" /><span className="bg-[#FF3B6C]" /><span className="bg-[#FFD600]" /></div>}
      <div ref={end} />
    </div>
  );
};
